module.exports = __webpack_public_path__ + "media/images/statusPage__503-9b9ee5875581a5c2a965130abd79b2b7.png";